import { Linking } from 'react-native'
import { platformConfig } from '../constants/platform'

export const openUrl = async (link: string) => {
  if (platformConfig.isIOS()) {
    Linking.canOpenURL('message:')
      .then(supported => {
        if (!supported) {
          console.log("Can't handle url")
        } else {
          return Linking.openURL(link)
        }
      })
      .catch(err => {
        console.error('An error occurred', err)
      })
  } else {
    await Linking.openURL(link)
  }
}
